/**
 * Hook que consulta /api/me y expone la sesión del usuario actual.
 *
 * No guarda tokens; solo info no-sensible (entra_object_id, nombre, isAdmin).
 */

import { useQuery } from '@tanstack/react-query';

import { api, ApiError } from '@/api/client';

export interface Me {
  entra_object_id: string;
  display_name: string;
  is_admin: boolean;
  csrf_token?: string;
}

export function useSession() {
  return useQuery<Me, ApiError>({
    queryKey: ['me'],
    queryFn: () => api<Me>('/api/me/'),
    retry: false,
  });
}
